import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M6 11.119A5.119 5.119 0 1 0 6 .88 5.119 5.119 0 0 0 6 11.12M4.82 8.363h2.362" />
      <path d="M6 8.363V5.606h-.787M6 3.834a.197.197 0 0 1 0-.394M6 3.834a.197.197 0 0 0 0-.394" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineInfo;
